import { NotificationsEnum, NotificationsTypesEnum } from '@shared/enums/notificationsEnum';
import { RightSidebarTabsEnum } from '@shared/enums/rightSidebarEnum';

import { updateFeedsCounter } from '../../Profile/profile.actions';
import {
  setProfileHubsGarageExpiredAtDate,
  setProfileNotificationsCount,
  setProfileNotificationsNewsCount,
} from '../../Profile/profile.slice';

import { showAllNews } from './notificationsActions';
import { addNewsItem, addRequestItem, deleteRequestItem, updateRequestItem } from './notificationsSlice';

import type { AppDispatch, RootState } from '../../store';
import type { NewsItemModel } from '@shared/models/notifications/news/newsItem.model';
import type { RequestItemModel } from '@shared/models/notifications/requests/requestItem.model';

export const notificationsGlobalSocketAddItem =
  (item: NewsItemModel) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const { activeTab } = getState().notifications;
    const { isOpenRightSidebar, rightSidebarSelectedTab } = getState().rightSidebar;

    if (
      isOpenRightSidebar &&
      rightSidebarSelectedTab === RightSidebarTabsEnum.notifications &&
      activeTab === NotificationsEnum.news
    ) {
      dispatch(addNewsItem(item));
      dispatch(showAllNews());
    } else {
      dispatch(setProfileNotificationsNewsCount(1));
    }
  };

export const notificationsGlobalSocketCreateItem =
  (item: RequestItemModel) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const { activeTab } = getState().notifications;

    if (activeTab === NotificationsEnum.requests) {
      dispatch(addRequestItem(item));
    }
    if (item.type === NotificationsTypesEnum.garage) {
      dispatch(setProfileHubsGarageExpiredAtDate(true));
    }
    dispatch(setProfileNotificationsCount(1));
  };

export const requestsGlobalSocketUpdateItem =
  (item: RequestItemModel) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const { activeTab } = getState().notifications;
    if (activeTab === NotificationsEnum.requests) {
      dispatch(updateRequestItem(item));
    }
  };

export const notificationsGlobalSocketDeleteItem =
  (id: number) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const { activeTab } = getState().notifications;

    if (activeTab === NotificationsEnum.requests) {
      dispatch(deleteRequestItem(id));
    }
    dispatch(updateFeedsCounter());
  };
